/**
 * @module components\ghTable\vuetifyTable\vuetifyRow
 */
import Vue from "vue";
import { Component, Prop, Inject } from "vue-property-decorator";
import VuetifyCell from "./vuetifyCell/vuetifyCell";

@Component({
  components: {
    ["vuetify-cell"]: VuetifyCell
  }
})
export default class VuetifyRow extends Vue {
  @Prop()
  props?: any;

  @Prop()
  headers?: ITableHeader[];

  @Inject()
  private bus: Vue;

  @Inject()
  syncProps: IGhTableSyncProps;

  private get IsSelected() {
    if (this.syncProps && this.syncProps.selectedItems) {
      return this.syncProps.selectedItems.length > 1;
    } else {
      return false;
    }
  }

  private clickRow(props: IndexObject) {
    if (this.syncProps && this.syncProps.selectedItems) {
      this.syncProps.selectedItems = [];
      this.syncProps.selectedItems.push(props.item);
      // props.selected = true;

      // console.log(props);
      // console.log(this.syncProps.selectedItems);
    }
  }

  private cellCheckRow(props) {
    props.selected = !props.selected;
  }

  private actions = [
    {
      icon: "mdi-content-copy",
      text: "复制本记录",
      event: "copyItem"
    },
    {
      icon: "edit",
      text: "编辑本记录",
      event: "editItem"
    },
    {
      icon: "delete",
      text: "删除本记录",
      event: "deleteItem"
    }
  ];

  mounted() {}
}
